import { useMemo } from "react";

import FeatureGates from "@atlaskit/feature-gate-js-client";

import { experiments, useExperiment } from "@/utils/experiment";

const VALID_SKU = ["confluence-standard", "confluence-premium"];

const VALID_SKU_EMPTY = ["confluence-free", "confluence-enterprise-sku"];

export function useDirectBuyExperiment(
    billingCycle: string,
    offeringSku?: string,
    shouldShowDirectBuy?: boolean
) {
    const isGateEnabled = FeatureGates.checkGate(
        "pricing_direct_buy_checkout_fg"
    );
    const experiment = useExperiment({
        ...experiments.pricingDirectBuyCheckout,
        options: {
            fireExperimentExposure: false,
            typeGuard: experiments.pricingDirectBuyCheckout.options.typeGuard
        }
    });
    const cohort = experiment.type === "enrolled" ? experiment.value : null;
    const isMonthly = billingCycle == "MONTHLY";
    const isVariation = cohort === "variation";

    const isValidEditionBtn = useMemo(
        () => (offeringSku ? VALID_SKU.includes(offeringSku) : false),
        [offeringSku]
    );
    const isValidEditionEmpty = useMemo(
        () => (offeringSku ? VALID_SKU_EMPTY.includes(offeringSku) : false),
        [offeringSku]
    );

    if (
        !offeringSku ||
        !isMonthly ||
        !isVariation ||
        !isGateEnabled ||
        !shouldShowDirectBuy
    ) {
        return {
            renderDirectBuyBtn: false,
            renderDirectBuyMatchSpace: false
        };
    }

    return {
        renderDirectBuyBtn: isValidEditionBtn,
        renderDirectBuyMatchSpace: isValidEditionEmpty
    };
}
